<ng-container>
  <button
    mat-button
    color="accent"
    aria-label="form.name"
    class="form-btn"
    (click)="openForm($event)"
  >
    @if (showIcon) { @if (!form.faIcon) {
    <mat-icon class="form-link" [ngClass]="form.icon"></mat-icon>
    } @else {
    <mat-icon><fa-icon class="form-link" [icon]="form.faIcon"></fa-icon></mat-icon>
    } }
    <span
      class="form-link-title {{
        specialClassForms.includes(form.enumId) ? 'd-inline-flex align-items-center' : ''
      }}"
      >{{ displayName }}</span
    >
  </button>
</ng-container>
